import { faUniversity } from "@fortawesome/free-solid-svg-icons";

import { useLanguage } from "../../../context/LanguageProvider";
import PageLayout from "../../../shared/components/layout/PageLayout";
import PageTitle from "../../../shared/components/layout/PageTitle";
import Wrapper from "../../../shared/components/layout/Wrapper";
import SEO from "../../../shared/components/layout/SEO";
import StatusMessage from "../../../shared/components/elements/StatusMessage";
import CourseCard from "../components/CourseCard"; // Move into this feature later

import { useCourses } from "../hooks/useCourses";
import { COURSE_MESSAGES } from "../messages";

const CourseListPage = () => {
    const { t } = useLanguage();
    const { courses, loading, error } = useCourses();

    // Picks what to show for each state of the request
    const renderContent = () => {
        if (loading) return <StatusMessage>{COURSE_MESSAGES.loadingList}</StatusMessage>;
        if (error) return <StatusMessage>{COURSE_MESSAGES.listFailed}</StatusMessage>;
        if (courses.length === 0) return <StatusMessage>{COURSE_MESSAGES.listEmpty}</StatusMessage>;

        return (
            <div className="flex flex-wrap">
                {courses.map((course) => (
                    <CourseCard key={course.id} course={course} />
                ))}
            </div>
        );
    };

    return (
        <>
            <SEO
                title={t.seo.courses.title}
                description={t.seo.courses.description}
                path="/course"
            />

            <PageLayout>
                <Wrapper>
                    <PageTitle title={COURSE_MESSAGES.courses} icon={faUniversity} />
                    <div className="w-full lg:mx-10">{renderContent()}</div>
                </Wrapper>
            </PageLayout>
        </>
    );
};

export default CourseListPage;